import React, {Component} from "react";
import AxiosMaster from '../../AxiosFactory';
import axios from "axios";
import withStyles from "@material-ui/core/styles/withStyles";
import Assignment from "@material-ui/icons/Assignment";
import FormControl from "@material-ui/core/FormControl";
import Switch from "@material-ui/core/Switch";
import InputLabel from "@material-ui/core/InputLabel";
import DropzoneComponent from 'react-dropzone-component';

import FormControlLabel from "@material-ui/core/FormControlLabel";
import api from "../../api/Api";
import {NavLink} from "react-router-dom";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// @material-ui/core components
import LinearProgress from '@material-ui/core/LinearProgress';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {
    verifyEmail,
    verifyName, currentDate,
    verifyAlphaNum,
    verifyNumber,
    verifyPhoneNumber, isClinicMasterOrClinic, getClinicUserId, clinicmaster_id, dashboardRouter
} from '../../util/globalHelper'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {reportCount, reload} from '../../redux/global'
// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import Loader from '../../components/Loader'

var removeByAttr = function (arr, attr, value) {
    var i = arr.length;
    while (i--) {
        if (arr[i]
            && arr[i].hasOwnProperty(attr)
            && (arguments.length > 2 && arr[i][attr] === value)) {

            arr.splice(i, 1);

        }
    }
    return arr;
}


class AddReportBatch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: false,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            simpleSelect: "",
            imageurl: '',
            clinicMasterList: null,
            clickedId: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],

            companyNumber: "",
            companyNumberState: "",
            alert: null,
            open: true,
            generatedclinicmaster_id: "",
            propss: props,
            clinicmaster_id: "",
            clinic_id: "",
            patient: null,
            clinicsData: null,
            accepted: [],
            rejected: [],
            files: [],
            file: null,
            upload: "none",
            uploading: false,
            hitSubmit: false,
            hitimage: false,
            imagePreviewUrl: null,
            removeoff: true,
            uploadprogress: 0,
            imageUrl: "",
            url: "",
            fileName: null,
            multipltFile: 0,
            autoCompleteReportValue: "",
            completed: 0,
            setCompleted: 0,
            hide: false
        };
        this.typeClick = this.typeClick.bind(this)
        this.autoSubmit = this.autoSubmit.bind(this)
        this.handlePost = this.handlePost.bind(this)
        this.setPhoneNumber = this.setPhoneNumber.bind(this)
        this.setReportTitle = this.setReportTitle.bind(this)
        this.onChangeSelect = this.onChangeSelect.bind(this)

        // For a full list of possible configurations,
        // please consult http://www.dropzonejs.com/#configuration
        this.djsConfig = {
            addRemoveLinks: true,
            // acceptedFiles: "image/jpeg,image/png,application/pdf",
            autoProcessQueue: true,

        };

        this.componentConfig = {
            // iconFiletypes: ['.jpg', '.png', '.pdf'],
            showFiletypeIcon: true,
            postUrl: '/uploadHandler'
        };

        this.dropzone = null;

        // If you want to attach multiple callbacks, simply
        // create an array filled with all your callbacks.
        this.callbackArray = [() => console.log('Hi!'), () => console.log('Ho!')];

        // Simple callbacks work too, of course.dropzone .dz-preview .dz-progress
        this.callback = (file) => {
            this.setState({imagePreviewUrl: true})
        };

        this.success = file => console.log('uploaded', file);

        this.removedfile = file => console.log('removing...', file);
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    handleFileAdded(file) {
    }

    handlePost() {
        // this.dropzone.processQueue();
        if (this.state.clinic_id !== "" && this.state.clinicmaster_id && this.dropzone.getAcceptedFiles().length > 0) {
            this.setState({multipltFile: this.dropzone.getAcceptedFiles().length, hide: true})
            this.dropzone.getAcceptedFiles().map((file, index) => {
                var postReport = {
                    "file_name": (new Date).getTime() + "_" + file.name.replace(/ /g, ''),
                    "type": file.type,
                    clinic_id: this.state.clinic_id,
                    custom_ftp: true
                };
                api.uploadReport(postReport).then(json => {
                    this.setState({imagePreviewUrl: json.data.data.url}, () => {
                        const bucket = json.data.data.url.split('.amazonaws')[0].split('://')[1].split('.')[0];
                        const url = AxiosMaster.ImageUrlUpload + json.data.data.complete_url + "/" + postReport.file_name;
                        this.handleImageUrl(url);
                        this.setState({imageUrl: url, url: url});
                        axios.put(this.state.imagePreviewUrl, file, {
                            headers: {
                                'Content-Type': file.type,
                                'User-Agent': '5c2a01a4040ca45d93c56843'
                            }
                        }).then(json => {
                            this.setState({upload: "success", uploading: false});
                            // var msgcolor = {
                            //     message: index+ + " of " + this.dropzone.getAcceptedFiles().length + " files uploaded!",
                            //     color: "success"
                            // };
                            // this.props.id.generateNotification(msgcolor);
                        }).catch(err => {
                            this.setState({upload: "error", uploading: false});
                            var msgcolor = {
                                message: index + 1 + " of " + this.dropzone.getAcceptedFiles().length + " files is not uploaded!",
                                color: "danger"
                            };
                            this.props.id.generateNotification(msgcolor);
                        });
                        var msgcolor = {
                            message: index + 1 + " of " + this.dropzone.getAcceptedFiles().length + " files uploaded!",
                            color: "success"
                        };
                        this.setState({completed: ((index + 1) * 100) / this.dropzone.getAcceptedFiles().length});
                        this.props.id.generateNotification(msgcolor);
                    });
                });
                // if(this.state.multipltFile>0&&this.state.multipltFile===this.props.reportCountState){
                //     this.autoSubmit();
                // }
            });
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }


    handleImageUrl(url) {
        var reportCount = this.state.report_link.length > 0 ? this.state.report_link.length : "";
        this.setState({
            // imageurl: url,
            report_link: this.state.report_link.concat({
                "link": url,
                "type": `${this.state.simpleSelect !== "" ? this.state.simpleSelect : "Others"}`
            })
        }, () => {
            // this.setState({imageurl: ''})
            this.props.reportCount(this.state.report_link.length)

        });
        // var msgcolor = {message: "Files Upload Successfully!", color: "success"};
        // this.props.id.generateNotification(msgcolor);

    }

    removeReport(url) {
        this.setState({report_link: this.state.report_link.splice(this.state.report_link.indexOf(this.state.report_link.find(item => item.link === url)), 1)})
    }

    changeExistingReport(url, preUrl) {
        let objIndex = this.state.report_link.length > 0 ? this.state.report_link.findIndex((obj => obj.link === preUrl)) : null;
        if (this.state.report_link.length > 0) {
            this.state.report_link[objIndex].link = url
        }
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            clickedId: suggestion._id,
            patient: suggestion,
            name: suggestion.user_id.name,
            nameState: 'success',
            contactNumber: suggestion.user_id.contact,
            contactNumberState: 'success',
            email: suggestion.user_id.email,
            emailState: 'success',
        });
        return suggestion.user_id.contact

    };

    getReportTitleSuggestionValue = (suggestion) => {
        this.setState({
            report: suggestion,
            reportTitle: suggestion.title,
            simpleSelect: suggestion.type,
            description: suggestion.description,
            descriptionState: 'success'
        });
        return suggestion.title

    };


    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.patientID)
        this.setState({clickedId: this.props.id.match.params.patientID})
        var str = '   <br /><br /> <Hospital style={{fontSize: 75}}/> <GridItem xs={12}> <h3>Upload Report Here</h3> </GridItem><h4>Looks like you have no reports yet.<br/> Click on the button below to add a reports. <br/><br/> </h4> ';
        var child = document.createElement('div');
        child.innerHTML = str;
        child = child.firstChild;
        // document.getElementsByClassName('dz-default') ? document.getElementsByClassName('dz-default')[0].appendChild(child) : null;

    }

    CallReadApi = (id) => {
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({
            clinicMasterList: {},
            clinicmaster_id: clinicmaster_id(),
            clinic_id: getClinicUserId()
        });
        var postBody = {
            "clinic_master_id": clinicmaster_id(),
            "_id": id
        };
        if (id) {
            api.fetchPatientDetailsByClinicMasterAndPatientID(postBody).then(json => {
                this.setState({patientDetail: json.data.data[0]}, () => {
                    this.setState({
                        name: this.state.patientDetail.user_id.name, nameState: 'success',
                        contactNumber: this.state.patientDetail.user_id.contact,
                        contactNumberState: 'success',
                        email: this.state.patientDetail.user_id.email,
                        emailState: 'success',
                    })
                })
            })
        }
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    componentWillUnmount() {
        this.setState({
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: false,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            last_name: "",
            last_nameState: "",
            number: "",
            autoCompleteValue: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            simpleSelect: "",
            imageurl: '',
            clinicMasterList: null,
            clickedId: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],
            filesToBeSent: [],

        })

    }

    setPhoneNumber(value) {
        this.setState({autoCompleteValue: value})
    }

    setReportTitle(value) {
        this.setState({autoCompleteReportValue: value})
    }

    onDrop(acceptedFiles, rejectedFiles) {
        // console.log('Accepted files: ', acceptedFiles[0].name);
        var filesToBeSent = this.state.filesToBeSent;
        filesToBeSent.push(acceptedFiles);
        this.setState({filesToBeSent});
    }

    componentWillUpdate() {
        // this.state.report_link.length > 0 && this.state.multipltFile === this.state.report_link.length ? this.autoSubmit() : null;
    }

    componentWillReceiveProps(nextProps) {
        // console.log(nextProps)
        if (nextProps.reportCountState === this.state.multipltFile && nextProps.reloadState !== true && nextProps.reportCountState !== this.props.reportCountState) {
            // this.autoSubmit()
            this.props.id.history.push(dashboardRouter("/report/getbatchfiles"));
        }
    }

    render() {
        const config = this.componentConfig;
        const djsConfig = this.djsConfig;

        // For a list of all possible events (there are many), see README.md!
        const eventHandlers = {
            init: dz => this.dropzone = dz,
            // addedfile: this.handleFileAdded.bind(this),
            // All of these receive the event as first parameter:
            drop: this.callbackArray,
            addedfile: this.callback,
            success: this.success,
            removedfile: this.removedfile,
            dragstart: null,
            dragend: null,
            dragenter: null,
            dragover: null,
            dragleave: null,
            // All of these receive the file as first parameter:
            // removedfile: null,
            thumbnail: null,
            error: null,
            processing: null,
            uploadprogress: null,
            sending: null,
            // success: null,
            complete: null,
            canceled: null,
            maxfilesreached: null,
            maxfilesexceeded: null,
            // All of these receive a list of files as first parameter
            // and are only called if the uploadMultiple option
            // in djsConfig is true:
            processingmultiple: null,
            sendingmultiple: null,
            successmultiple: null,
            completemultiple: null,
            canceledmultiple: null,
            // Special Events
            totaluploadprogress: null,
            reset: null,
            queuecomplete: null
        };
        const {classes} = this.props;
        const {clinicLis, clinicsData, clinicMasterList, completed, setCompleted} = this.state;
        if((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && (this.state.clinicsData[0] ? this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id : true) || this.state.clinicsData === [])) { this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id) }
        if (this.state.clinicMasterList)
            return (
                <div>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <h4 className={classes.cardTitle}>Upload Batch Report</h4>
                                    </CardText>

                                </CardHeader>
                                <CardBody>
                                    <form>
                                        <GridContainer>
                                            {isClinicMasterOrClinic() === "" ?
                                                <GridItem xs={12} sm={6} className="centerDiv">
                                                    <FormControl
                                                        fullWidth>
                                                        <InputLabel
                                                            htmlFor="clinicmaster_id">
                                                            Clinic Master
                                                        </InputLabel>
                                                        <Select
                                                            value={this.state.clinicmaster_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinicmaster_id",
                                                                id: "clinicmaster_id"
                                                            }}
                                                        >
                                                            <MenuItem
                                                                disabled
                                                            >
                                                                Select Clinic
                                                            </MenuItem>
                                                            {clinicMasterList.map((x) => {
                                                                return <MenuItem key={Math.random()}
                                                                                 style={{height: "1.8em"}}
                                                                                 value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                    <br/>
                                                </GridItem> : null}
                                            {isClinicMasterOrClinic() === "" || isClinicMasterOrClinic() ?
                                                <GridItem xs={12} sm={6} className="centerDiv">

                                                    {this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                                        <FormControl
                                                            fullWidth>
                                                            <InputLabel
                                                                htmlFor="clinic_id">
                                                                Clinic
                                                            </InputLabel>
                                                            <Select
                                                                value={this.state.clinic_id}
                                                                onChange={this.onChangeSelect}
                                                                inputProps={{
                                                                    name: "clinic_id",
                                                                    id: "clinic_id"
                                                                }}
                                                            >
                                                                <MenuItem
                                                                    disabled
                                                                >
                                                                    Select Clinic
                                                                </MenuItem>
                                                                {clinicsData.length > 0 ? clinicsData.map((x) => {
                                                                    return <MenuItem key={Math.random()}
                                                                                     style={{height: "1.8em"}}
                                                                                     value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                                }) : null}
                                                            </Select>
                                                        </FormControl> : null}
                                                </GridItem> : null}

                                        </GridContainer>

                                        <GridContainer>

                                            <GridItem xs={12} sm={6}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={this.state.checkedA}
                                                            onChange={this.handleChange("checkedA")}
                                                            value="checkedA"
                                                            classes={{
                                                                switchBase: classes.switchBase,
                                                                checked: classes.switchChecked,
                                                                icon: classes.switchIcon,
                                                                iconChecked: classes.switchIconChecked,
                                                                bar: classes.switchBar
                                                            }}
                                                        />
                                                    }
                                                    classes={{
                                                        label: classes.label
                                                    }}
                                                    label="No Payment Dues"
                                                />
                                            </GridItem>

                                        </GridContainer>
                                        <Card>
                                            <GridItem>
                                                <GridContainer className={classes.justifyContentCenter}
                                                               style={{justifyContent: 'center', textAlign: 'center'}}>
                                                    <div>
                                                        <br/><br/>
                                                        <Assignment style={{fontSize: 65}}/>
                                                        <br/>

                                                        {this.state.report ?
                                                            <h4>Reports</h4> : <div>
                                                                <h3>Upload Report Here</h3>
                                                                <h4>
                                                                    Looks like you have no reports yet.<br/>
                                                                    Click on the button below to add reports<br/><br/>
                                                                </h4></div>}
                                                    </div>
                                                    <br/>

                                                    <br/>
                                                    <GridContainer className={classes.justifyContentCenter}
                                                                   style={{
                                                                       justifyContent: 'center',
                                                                       textAlign: 'center'
                                                                   }}>
                                                        <GridItem>

                                                            <DropzoneComponent config={config}
                                                                               eventHandlers={eventHandlers}
                                                                               djsConfig={djsConfig}>Select Report
                                                                {/*<br /><br />*/}
                                                                {/*<div className="dz-default dz-message"*/}
                                                                {/*style={{width: '100%'}}>*/}
                                                                {/*Select Reports*/}
                                                                {/*</div>*/}
                                                            </DropzoneComponent>
                                                            <br/>
                                                        </GridItem>
                                                    </GridContainer>
                                                </GridContainer>

                                                <br/><br/>
                                                {this.state.hide ?
                                                    <LinearProgress variant="determinate" value={completed}/> : null}
                                                <br/>
                                            </GridItem>
                                        </Card>
                                    </form>
                                </CardBody>
                                <CardFooter style={{marginBottom: 25, paddingTop: 0}} className={"centerDiv"}>
                                    <GridContainer className={classes.justifyContentCenter}>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <Button block size="lg" color="warning" onClick={this.typeClick}>
                                                Save
                                            </Button>
                                        </GridItem>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <NavLink to={dashboardRouter(`/reports/readReports`)}>
                                                <Button block size="lg">
                                                    Cancel
                                                </Button>
                                            </NavLink>
                                        </GridItem>
                                    </GridContainer>
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    typeClick() {
        this.handlePost();
    }

    autoSubmit() {
        if (this.state.clinic_id !== "" && this.state.autoCompleteValue !== "" && this.state.clinicmaster_id && this.state.report_link.length > 0 && this.state.autoCompleteReportValue !== "") {
            var data = this.state.clickedId ? {
                "clinic_id": this.state.clinic_id,
                "patient_id": this.state.clickedId,
                "title": this.state.autoCompleteReportValue,
                "clinic_master_id": this.state.clinicmaster_id,
                "appointment_id": "",
                "amount": "",
                "date": currentDate(),
                "paid": this.state.checkedA,
                "description": this.state.description,
                "report_link": this.state.report_link
            } : {
                "clinic_id": this.state.clinic_id,
                "name": this.state.name,
                "contact": this.state.autoCompleteValue,
                "email": this.state.email,
                "title": this.state.autoCompleteReportValue,
                "clinic_master_id": this.state.clinicmaster_id,
                "appointment_id": "",
                "amount": "",
                "date": currentDate(),
                "paid": this.state.checkedA,
                "description": this.state.description,
                "report_link": this.state.report_link
            };
            api.createReport(data).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({redirect: true});
                    var msgcolor = {message: "Report Added Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.props.id.history.push(dashboardRouter(`/report/readReports`));
                }
            }).catch(error => {
                var msgcolor = {message: "Server Error!", color: "danger"};
                this.props.id.generateNotification(msgcolor);
            })
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

    handleChange = name => event => {
        this.setState({[name]: event.target.checked});
    };
}

const mapStateToProps = ({global}) => ({
    reportCountState: global.reportCountState,
    reloadState: global.reloadState,
})

const mapDispatchToProps = dispatch => bindActionCreators({
    reportCount, reload
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(validationFormsStyle)(AddReportBatch));



// WEBPACK FOOTER //
// ./src/components/Reports/addReportBatchDrag.jsx